export const SnackbarSlideDuration = 200;
export const SnackbarWidth = 360;
